import { useDispatch, useSelector } from "react-redux";
import styles from "./index.module.scss";
import Button from "../../../common/button";
import { showPopup } from "/redux/action-creaters/popup";
import { popupTypes } from "/redux/reducers/popupReducer";
import Delivery from "/components/pages/product/delivery";
import Files from "../../../pages/product/files";
import Sert from "../../../pages/product/sert";
import Props from "../../../common/product/props";
import { formatType } from "../../../../utils";

export default function LandingOffer() {
  const { product } = useSelector((state) => state.product);
  const dispatch = useDispatch();
  const quantity = product.CATALOG.QUANTITY;
  const isAlailable = product.CATALOG.AVAILABLE;
  const price = product.CATALOG.MIN_PRICE;
  const noDiscoutPrice = product.CATALOG.PRICE;
  const edostMinPriceCorrected = 0;
  const priceWithCity = price + edostMinPriceCorrected;

  return (
    <>
      <div
        className={styles.Price}
        itemProp="offers"
        itemScope
        itemType="http://schema.org/Offer"
      >
        <h1 itemProp="name">{formatType(product.NAME)}</h1>
        <div className={styles.Qty}>
          {quantity > 0 ? (
            <span className={styles.InStock}>В наличии: {quantity} шт</span>
          ) : (
            <span className={styles.OutOfStock}>Нет в наличии</span>
          )}
          <div>
            <span>Арт. {product.ARTICLE?.VALUE}</span>
          </div>
        </div>
        {isAlailable && noDiscoutPrice > price && (
          <div className={styles.BeforeValue}>{noDiscoutPrice} руб.</div>
        )}
        <div className={styles.Value}>
          {isAlailable && (
            <>
              <span>
                <span itemProp="price">{priceWithCity}</span> руб.
              </span>
            </>
          )}
        </div>
        <span itemProp="priceCurrency" style={{ display: "none" }}>
          RUB
        </span>
        {product.PROPERTIES.length > 0 && (
          <div className={styles.PropsBlock}>
            <div className={styles.PropsTitle}>Характеристики</div>
            <Props
              props={product.PROPERTIES}
              filterUrl={product.FILTER_URL}
              isLanding={true}
            />
          </div>
        )}
      </div>
      <div className={styles.Delivery}>
        <Delivery isLanding={true} />
      </div>

      <div className={styles.FilesAndBrands}>
        <div className={styles.Files}>
          <Files file={product.FILE} isLanding={true} />
          <Sert sert={product.CERT} isLanding={true} />
        </div>
      </div>
      <div className={styles.Bottom}>
        {isAlailable ? (
          <>
            <link itemProp="availability" href="http://schema.org/InStock" />
            <div className={styles.Buttons}>
              <Button
                onClick={async () => {
                  window.open(
                    `https://farkop.ru${product.DETAIL_PAGE_URL}`,
                    "_blank",
                  );
                }}
                label={"Купить"}
              />
            </div>
            <div className={styles.InfoCart}>
              Покупка производится на сайте партнера farkop.ru
            </div>
          </>
        ) : (
          <>
            <link itemProp="availability" href="http://schema.org/OutOfStock" />
            <Button
              type="outline"
              label={"Оформление предзаказа"}
              onClick={() => {
                dispatch(
                  showPopup(popupTypes.subscribeProduct, {
                    name: `${product.NAME} (арт ${product.ARTICLE?.VALUE}) (id ${product.ID})`,
                    // eslint-disable-next-line no-undef
                    id: productId,
                  }),
                );
              }}
            />
          </>
        )}
      </div>
    </>
  );
}
